export default __webpack_public_path__ + "static/media/package-5.d274a529.svg";